export class FrontendScriptNode {

    constructor(public id = "", public name = "", public sortName = "") {
    }
    
    getSortName(): string {
        return this.sortName ?? this.name;
    }
}
